import { data } from "jquery";
import { stringify } from "qs";
import Config from "@/assets/js/comm";

const paging = {
  data() {
    return {
      getApiType: true,
      printId: null,
      dialogFrom:{
        dialogVisible: false,
      },
      selectTableData: [], //  表格选中的数据
      classNameArr: [
        {
          name: "标签打印",
          val: "print_data_into_stock_bill",
        },
      ], // 默认的模板类型
      modelClassName: "",
      printClassName: "",
      conditonKey: '',
      apiNumber: '',
      exportForm: {
        isShowDialog_dc: false,
        diaWidth_dc: "60%",
        dialogTitle_dc: "导出数据",
        dialogForm_dc: {
          pageStart: 1,
          pageTotal: "",
          fileName: "到柜列表",
          apiName: "/v1/common/query/runPageReport",
          EpType: "dd", //dd===等待下载完成,bdd===不等待完成
          apiType: "POST",
          isJson: 1,
        },
        queryForm: [],
        EPtableHeard: [],
        EPAllCheck: false,
        reqNumber: '',
      },
      exportModeList: {
        modelData: {},
      },
    };
  },

  methods: {

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    printSetting() {
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEvent(this.selectTableData,true)
        return
      }
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // 打印
    printEvent(row) {
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEvent(row ? [row] : this.selectTableData)
        return
      }
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // 直接打印
    printEventNow(row) {
      console.info("直接打印1",row)
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEventNow(row ? [row] : this.selectTableData)
        return
      }

      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // ******************************  导出 (开始)*********************************
    handleExportDia_dc(fileName) {
      this.exportForm.isShowDialog_dc = true;
      this.exportForm.EPAllCheck = true;
      this.exportForm.queryForm = JSON.parse(JSON.stringify(this.queryCondditionDatas));
      this.exportForm.queryForm = this.exportForm.queryForm.filter((item) => item.isShow === 1);
      this.exportForm.queryForm.forEach((item) => {
        if (this.exportModeList.modelData[item.conditonKey]) {
          item.conditonVal =
              this.exportModeList.modelData[item.conditonKey];
        }
      });
      this.exportForm.EPtableHeard = this.myTableHeard;
      this.exportForm.dialogForm_dc.fileName = fileName;
      this.exportForm.reqNumber = this.reportFiledsNumber;
    },
    handleCloseDia_dc() {
      this.exportForm.isShowDialog_dc = false;
    },
    checktabEP(idx, e, arrs) {
      console.info("checktabEP.e", e)
      arrs[idx].isShow = e ; //=== true ? 1 : 0
      let selectLength = 0;
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].isShow === 1) {
          selectLength++;
        }
      }
      // console.log(selectLength, arrs, arrs.length);
      if (selectLength === arrs.length) {
        this.exportForm.EPAllCheck = true;
      } else {
        this.exportForm.EPAllCheck = false;
      }
      this.exportForm.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    checkAllEP(e, arrs) {
      this.exportForm.EPAllCheck = e;
      for (var j = 0; j < arrs.length; j++) {
        arrs[j].isShow = e === true ? 1 : 0;
      }
      this.exportForm.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    onAfterEnter(arrs) {
      this.exportForm.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    diaConfirmBtn_dc() {
      let conditionReqs = [];
      conditionReqs = this.getConditionRes();
      let params = {
        conditionReqs,
        pageStart: this.exportForm.dialogForm_dc.pageStart,
        pageTotal: this.exportForm.dialogForm_dc.pageTotal,
        number: this.exportForm.reqNumber,
      };
      let hArrs = [];

      this.exportForm.EPtableHeard.forEach((element) => {
        if (element.isShow === 1) {
          let obj = {
            fieldKey: element.fieldAlias || element.field,
            titleValKey: element.fieldNameShow || element.name,
          };
          hArrs.push(obj);
        }
      });

      let d = {
        fileName: this.exportForm.dialogForm_dc.fileName || "fileName",
        headsTitles: JSON.stringify(hArrs), //表头 数组
        pageCount: this.exportForm.dialogForm_dc.pageTotal || 20000, //数据总条数 最多两万
        post: this.exportForm.dialogForm_dc.apiType || "GET",
        selectDto: JSON.stringify(params), //列表查询条件
        sheetName: this.exportForm.dialogForm_dc.fileName || "sheetName",
        url: Config.baseURL + this.exportForm.dialogForm_dc.apiName,
        isJson: this.exportForm.dialogForm_dc.isJson, //是否json 1= 是 0= 否
      };
      if (this.exportForm.dialogForm_dc.EpType === "dd") {
        // 等待导出完成
        // 生成导出文件流,前端转换下载
        this.$API.exportExcelByUrl(d).then((res) => {
          let data = res.data;
          // 获取响应的文件流数据
          const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let url = URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download =
              (this.exportForm.dialogForm_dc.fileName || "导出文件") + ".xlsx"; // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url); // 撤销URL对象

          setTimeout(() => {
            this.exportForm.isShowDialog_dc = false;
          }, 1000);
        });
      } else {
        // 导出(生成历史记录),只返回提示
        this.$API.exportExcelToRecord(d).then((res) => {
          this.$message("数据处理中,请到右上角导出记录中查询结果" );

          setTimeout(() => {
            this.exportForm.isShowDialog_dc = false;
          }, 1000);
        });
      }
    },
    // ******************************  导出 (结束)*********************************
  },
};

export default paging;
